import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { Company } from "../../models/Companies";
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Companies form
 */

export class CompanyForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Название',
      name: 'title',
      required: true
    }, {
      label: 'Тип',
      name: 'type',
      type: BaseForm.TYPES.DROPDOWN,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Company.companiesTypes)
        }
      }
    }, {
      label: 'Тип продаж',
      name: 'sellingType',
      type: BaseForm.TYPES.DROPDOWN,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Company.companiesSellingTypes)
        }
      }
    }, {
      label: 'Адрес',
      name: 'address',
      type: BaseForm.TYPES.CUSTOM
    }, {
      label: 'Широта',
      name: 'latitude'
    }, {
      label: 'Долгота',
      name: 'longitude'
    }, {
      label: 'Сайт',
      name: 'site'
    }, {
      label: 'Телефон',
      name: 'phone'
    }, {
      label: 'E-mail',
      name: 'email'
    }, {
      label: 'Партнёр',
      name: 'isPartner',
      type: BaseForm.TYPES.TOGGLE
    }, {
      label: 'Оплата онлайн',
      name: 'isOnlinePay',
      type: BaseForm.TYPES.TOGGLE
    }, {
      label: 'Описание',
      name: 'description',
      type: BaseForm.TYPES.EDITOR
    }];
    this.dispatchCreateForm = DispatchSelector.companies.create;
    this.dispatchUpdateForm = DispatchSelector.companies.update;
    this.responseCreateState = StateSelector.companies.create;
    this.responseUpdateState = StateSelector.companies.update;
  }

}